import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { HowItWorks } from "./components/howItWorks";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import { BlogIndex, BlogPost, BlogPreview, NotFound } from "./blog/BlogPages";
import JsonData from "./data/data.json";

// Shared by the browser and build-time renderer. No analytics or network requests here.
export default function PublicSite({ isTranscriptionCountLoading = false, transcriptionCount = null }) {
  return <>
    <a className="skip-link" href="#main-content">Skip to content</a>
    <Navigation />
    <Routes>
      <Route path="/" element={<main id="main-content" className="app-main">
        <Header data={JsonData.Header} isTranscriptionCountLoading={isTranscriptionCountLoading} transcriptionCount={transcriptionCount} />
        <HowItWorks data={JsonData.HowItWorks} />
        <About data={JsonData.About} />
        <BlogPreview />
        <Contact data={JsonData.Contact} />
      </main>} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/terms-and-conditions" element={<Navigate replace to="/terms-of-service" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </>;
}
